import React from 'react';
import './buttonOptionGroup.scss';

/**
 * Component that renders an array of options to select from
 * @param {Array} options Array of options to render 
 * @param {Function} onOptionClick Callback function to execute on clicking an option 
 * @param {Number} selectedOption Index value of the selected option 
 * @returns {Component} JSX component
 */
export const ButtonOptionGroup = ({
    options = [],
    onOptionClick,
    selectedOption,
    disabled,
    fitContent = false,
    name
}) => {
    return (
        <div className={`option-group-container ${fitContent ? 'fit-content' : ''}`}>
            {options.map((option, index) => (
                <button
                    disabled={disabled}
                    name={name}
                    key={option?.id || option}
                    id={option?.id || option}
                    onClick={(e) => onOptionClick(index, e)}
                    className={`option-button ${selectedOption === (option?.id || index) && 'selected' || ''}`}
                >
                    {option?.displayName || option}
                </button>
            ))}
        </div>
    )
}